export default __webpack_public_path__ + "static/media/frame_th_sp.0f7586d4.png";